export const detachedDeepFreeze = <T>(value: T): Readonly<T> => {
  const copy = JSON.parse(JSON.stringify(value)) as T;

  const freeze = (current: unknown): void => {
    if (!current || typeof current !== 'object' || Object.isFrozen(current)) {
      return;
    }
    Object.values(current).forEach(freeze);
    Object.freeze(current);
  };

  freeze(copy);
  return copy;
};
